import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { formatCurrency } from 'legacy/utils/formatCurrency'

const Wrapper = styled.div`
  font-size: ${({ large }) => (large ? '24px' : '22px')};
  font-weight: bold;
  flex-shrink: 0;
  color: ${getToken('color-neutral-darkest')};

  ${({ isPriceRange, darkThemed }) =>
    isPriceRange &&
    `
     position: relative;
    margin-right: 8px;

    &::before {
        content: 'Starting at';
        position: absolute;
        top: -16px;
        left: 0;
        min-width: 80px;
        overflow: hidden;
        font-size: 12px;
        font-weight: 500;
    }`};
`

function Price(props) {
  const { price, darkThemed, isPriceRange, decimals, ...rest } = props

  const formattedPrice = formatCurrency(price, decimals)

  return (
    <Wrapper darkThemed={darkThemed} {...rest} isPriceRange={isPriceRange}>
      {formattedPrice}
    </Wrapper>
  )
}

Price.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  isPriceRange: PropTypes.bool,
  darkThemed: PropTypes.bool,
  large: PropTypes.bool,
  decimals: PropTypes.bool,
}

Price.defaultProps = {
  isPriceRange: false,
  darkThemed: false,
  large: false,
  decimals: false,
}

export { Price }
